/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';

import {
  saleCleanSuccess,
  saleSetSuccess,
  saleLookupInit,
  saleLookupSuccess,
  saleLookupFail,
} from 'state/actions/sales';

export const initialState = {
  loading: false,
  error: null,
};

const saleReducer = createReducer(initialState, {
  [saleCleanSuccess]: (state) => {
    state.token = null;
    state.customer = null;
    state.sale = null;
    state.loading = false;
    state.error = null;
  },
  [saleSetSuccess]: (state, action) => {
    const { number, total } = action.payload;
    state.number = number;
    state.total = total;
  },
  [saleLookupInit]: (state) => {
    state.loading = true;
    state.error = null;
  },
  [saleLookupSuccess]: (state, action) => {
    const { token, customer, sale } = action.payload;
    state.token = token;
    state.customer = customer;
    state.sale = sale;
    state.loading = false;
    state.error = null;
  },
  [saleLookupFail]: (state, action) => {
    const { error } = action.payload;
    state.loading = false;
    state.error = error;
  },
});

export default saleReducer;
